import styled from 'styled-components';

/**
 * Styled shell around AgGridReact. Holds only project-neutral sizing + font.
 * Grid colours/borders/radius come from the Theming API in CommonAgGrid.tsx,
 * so consumers stay free of any `.css` import.
 */
export const GridShell = styled.div<{ $height: string }>`
  width: 100%;
  height: ${({ $height }) => $height};
  font-family: var(--font-book), 'Aktiv Grotesk', system-ui, sans-serif;

  .ag-root-wrapper {
    border-radius: var(--border-radius-common, 2px);
  }

  /* Header chrome — set here rather than via theme params (project tokens). */
  .ag-header,
  .ag-header-cell,
  .ag-header-group-cell {
    background-color: var(--titleBG, #f3f3f3);
  }

  /* Keep header group + column labels on the medium Aktiv Grotesk weight. */
  .ag-header-group-cell-label,
  .ag-header-cell-text {
    font-family: var(--font-heavy), 'Aktiv Grotesk Medium', system-ui, sans-serif;
  }
`;
